import React from 'react';
import { Clock } from 'lucide-react';
import './ProcessingCard.css';

export const ProcessingCard = ({ thumbnail, title, progress, estimatedMinutes }) => {
    const clampedProgress = Math.min(100, Math.max(0, progress || 0));
    const etaMinutes = estimatedMinutes != null ? Math.ceil(estimatedMinutes) : null;

    return (
        <div className="processing-card">
            <div className="processing-thumbnail-container">
                {thumbnail ? (
                    <img
                        src={thumbnail}
                        alt={title || 'Processing video'}
                        className="processing-thumbnail"
                    />
                ) : (
                    <div className="processing-thumbnail-placeholder" />
                )}

                <div className="processing-progress-overlay">
                    <div className="processing-progress-pill">
                        <Clock size={18} className="progress-icon" />
                        <span className="progress-text">
                            {clampedProgress}%
                            {etaMinutes != null && ` (ETA ${etaMinutes}m)`}
                        </span>
                    </div>
                </div>
            </div>

            <div className="processing-info">
                <h3 className="processing-title" title={title}>
                    {title || 'Processing video...'}
                </h3>
                <div className="processing-bar-container">
                    <div
                        className="processing-bar-fill"
                        style={{ width: `${clampedProgress}%` }}
                    />
                </div>
            </div>
        </div>
    );
};
